import { ReactNode } from "react";
import { styles } from "./styles";

type Props = {
  children: ReactNode;
};

export default function LeftColumn({ children }: Props) {
  return <styles.MainContainer>{children}</styles.MainContainer>;
}
